<template>
  <div
    ref="dialog"
    class="mdc-dialog"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="my-dialog-title"
    aria-describedby="my-dialog-content"
    @keyup.enter="onClickOnSubmit()"
  >
    <div class="mdc-dialog__container">
      <div class="mdc-dialog__surface">
        <h2 class="mdc-dialog__title" id="my-dialog-title">
          <i class="material-icons">list_alt</i> Customer segments
        </h2>
        <div class="mdc-dialog__content" id="my-dialog-content">
          <p>To build an effective business model, a company must identify which customers it tries to serve.</p>
          <p>Various sets of customers can be segmented based on their different needs and attributes to ensure appropriate implementation of corporate strategy to meet the characteristics of selected groups of clients.</p>
        </div>
        <footer class="mdc-dialog__actions">
          <button
            type="button"
            class="mdc-button mdc-dialog__button"
            data-mdc-dialog-action="close"
          >
            <span class="mdc-button__label">Cancel</span>
          </button>
        </footer>
      </div>
    </div>
    <div class="mdc-dialog__scrim"></div>
  </div>
</template>

<script>
import { MDCDialog } from "@material/dialog";
import Input from "../Input.vue";

export default {
  props: ["visible"],
  mounted() {
    this.dialog = new MDCDialog(this.$refs.dialog);
    this.dialog.listen("MDCDialog:closed", () => {
      this.$emit("onClosed");
    });
    this.visible && this.dialog.open();
  },
  data() {
    return {
      dialog: null
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.dialog.open();
      } else {
        this.dialog.close();
      }
    }
  },
  components: {
    Input
  }
};
</script>

<style lang="scss" scoped>
.mdc-dialog__title {
  display: flex;
  align-items: center;
  font-size: 18px;
  text-transform: uppercase;
  font-weight: 300;
  margin: 10px 0;
  i {
    margin-right: 10px;
  }
}
.mdc-dialog__surface {
  min-width: 380px;
  max-width: 380px;
}
.separator {
  height: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/help-dialog/CustomerSegmentsHelpDialog.vue